import { Box, Flex, Text, Tooltip } from '@chakra-ui/react';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import Spinner from 'components/Spinner';
import { getDashboardBlocks } from 'redux/DashboardSliceV2';
import { getDataTypeBasedValuewithNewValue } from 'utils/FormatValues';

import { BaseInstrumentProperties } from './proptypes';

export const KpiInstrument = ({ widget, output }: BaseInstrumentProperties) => {
  const modalBlocks = useSelector(getDashboardBlocks);
  const [isLoading, setIsLoading] = useState(false);
  const [totalValues, setTotalValues] = useState<number | null>(null);

  const dataType = useMemo(() => {
    try {
      const foundBlock: any = modalBlocks.find((block: any) => {
        return block.block_id === widget.instrument_indicators[0].block_id;
      });

      if (foundBlock?.indicators) {
        const indicator = foundBlock?.indicators.find((ind: any) => {
          return widget?.instrument_indicators[0]?.indicator_id === ind.indicator_id;
        });
        return {
          data_format: indicator?.data_format ?? '',
          formatProperties: indicator?.data_format_properties ?? {},
        };
      }
    } catch {
      return null;
    }
    return null;
  }, [widget?.instrument_indicators?.length, modalBlocks]);

  useEffect(() => {
    if (widget?.id && output) {
      setIsLoading(false);
      // Scan for the first numeric value in the row rather than blindly taking
      // the first key — the no-Time pivot returns {values: 'Values', Name: 1234}
      // so Object.keys()[0] would give the string 'Values' instead of the number.
      const rows: any[] = output?.data ?? [];
      let found: number | null = null;
      if (rows.length > 0) {
        const foundKey = Object.keys(rows[0]).find((key) => typeof rows[0][key] === 'number');
        if (foundKey !== undefined) found = rows[0][foundKey] as number;
      }
      setTotalValues(found);
    }
  }, [widget, output]);

  return (
    <Box height='100%' width='100%' borderRadius='15px'>
      {isLoading && (
        <Flex
          height={'100%'}
          direction='column'
          alignItems='center'
          justifyContent='center'
          justify='center'
          align='center'
          w={'full'}
        >
          <Spinner size='xl' />
        </Flex>
      )}
      {!isLoading && (
        <Flex
          flexDirection='column'
          justifyContent='space-between'
          alignItems='space-between'
          className='dashboard-drag-header'
          cursor='grab'
        >
          <Box marginY={3}>
            <Flex marginInline={4} justifyContent='space-between' alignItems='center' gap={5}>
              <Tooltip
                label={
                  totalValues === null || totalValues === undefined || totalValues === 0
                    ? 0
                    : dataType
                    ? getDataTypeBasedValuewithNewValue(
                        dataType.data_format,
                        totalValues,
                        dataType.formatProperties,
                      )
                    : totalValues
                }
              >
                <Text
                  flex={1}
                  minWidth={0}
                  w={'100%'}
                  fontSize={{ base: '22px', sm: '22px', md: '22px', lg: '28px', xl: '34px' }}
                  fontWeight='400'
                  color={'#57519C'}
                  className='text-overflow'
                >
                  {totalValues === null || totalValues === undefined || totalValues === 0
                    ? 0
                    : dataType
                    ? getDataTypeBasedValuewithNewValue(
                        dataType.data_format,
                        totalValues,
                        dataType.formatProperties,
                      )
                    : totalValues}
                </Text>
              </Tooltip>
            </Flex>
          </Box>
        </Flex>
      )}
    </Box>
  );
};

export default KpiInstrument;
